"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "fixed z-50 top-0 left-0 w-screen h-screen bg-black bg-opacity-50 flex justify-center items-start p-5 md:py-20 overflow-y-auto" };
const _hoisted_2 = { class: "bg-beige-200 rounded-3xl w-full max-w-[960px]" };
const _hoisted_3 = { class: "flex justify-end" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "mx-5 sm:mx-10 md:mx-28 mb-10 md:mb-20" };
const _hoisted_6 = { class: "text-2xl md:text-6xl uppercase font-extrabold leading-squished mb-5" };
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'TeleportModal',
    emits: ['close'],
    setup(__props, { emit }) {
        // Janky setup as a workaround for this bug:
        // https://github.com/vuejs/core/issues/2855
        const Teleport = vue_3.Teleport;
        let scrollY = null;
        function close() {
            emit('close');
        }
        (0, vue_3.onMounted)(() => {
            scrollY = window.scrollY;
            document.body.classList.add('fixed', 'left-0', 'right-0');
            document.documentElement.style.overflow = 'scroll';
            document.body.style.top = `-${scrollY}px`;
        });
        (0, vue_3.onUnmounted)(() => {
            document.documentElement.style.scrollBehavior = 'auto';
            document.body.classList.remove('fixed', 'left-0', 'right-0');
            (0, vue_3.nextTick)(function () {
                window.scrollTo(0, scrollY);
                document.documentElement.style.scrollBehavior = 'smooth';
                document.documentElement.style.overflow = '';
            });
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)((0, vue_2.unref)(Teleport)), { to: "body" }, {
                default: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createElementVNode)("div", _hoisted_1, [
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                (0, vue_2.createElementVNode)("button", {
                                    class: "w-20 h-20 text-8xl leading-zero",
                                    type: "button",
                                    onClick: (0, vue_2.withModifiers)(close, ["prevent"])
                                }, " × ", 8, _hoisted_4)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                (0, vue_2.createElementVNode)("h2", _hoisted_6, [
                                    (0, vue_2.renderSlot)(_ctx.$slots, "header")
                                ]),
                                (0, vue_2.renderSlot)(_ctx.$slots, "default")
                            ])
                        ])
                    ])
                ]),
                _: 3
            }));
        };
    }
});
